<h2 class="mbottom-12">{{ 'paymentMethodAddTitle' | commonPaymentWording | async }}</h2>
<yat-add-new-payment-method id="fe22c1be-ce1e-4e02-9aa8-019eda283e53" (add)="createPaymentMethod($event)" [selectedWalletPaymentMethodType]="stashedWallet"> </yat-add-new-payment-method>

<ng-container *yatVar="walletButtonsTemplate && stashedWallet as showWallet">
  <div class="row mt-4" *ngIf="showWallet">
    <div class="col-12">
      <ng-container *ngTemplateOutlet="walletButtonsTemplate ?? null; context: { $implicit: stashedWallet }"></ng-container>
    </div>
  </div>
  <div class="row" [class.mt-2]="showWallet" [class.mt-4]="!showWallet">
    <div class="col-12">
      <button yat-button type="button" class="btn btn-large secondary-weak w-100" routerLink="../payment-method-selection">
        {{ 'back' | commonWording | async }}
      </button>
    </div>
  </div>
</ng-container>
